import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Downloads from './pages/Downloads';
import Ductlines from './pages/Ductlines';

function App() {
    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/downloads/samples/:sample" element={<Downloads />} />
                <Route path="/downloads/*" element={<Downloads />} />
                <Route path="/ductlines/*" element={<Ductlines />} />
            </Routes>
        </div>
    );
}

export default App;
